import { ApiPageResult } from 'api';
import { CommissionReportListItemDTO } from 'common/dto';
import { objectToQuery } from 'common/utils';

const BASE_URL = process.env['REACT_APP_PAS_BASE_URL'];

export const commissionReportApi = {
	getList: async (criteria: any = {}, token: string): Promise<ApiPageResult<CommissionReportListItemDTO>> => {
		try {
			const response = await fetch(`${BASE_URL}/commissionReport?${objectToQuery(criteria)}`, {
				headers: { 'Authorization': `Bearer ${token}` }
			});
			return await response.json();
		} catch (e) {
			return { error: String(e) };
		}  
	},

}

export default commissionReportApi;